import type { GlowSkin } from '../../../shared/components';

export const GLOW_SKIN = {
  STANDART: '00_Standart',
  CONSUMER: '01_Consumer',
  INDUSTRIAL: '02_Industrial',
  MIL_SPEC: '03_Mil-spec',
  RESTRICTED: '04_Restricted',
  CLASSIFIED: '05_Classified',
  COVERT: '06_Covert',
  EXTRAORDINARY: '07_Extraordinary',
  CONTRABAND: '08_Contraband',
  COVER: '09_Cover',
} as const satisfies Record<string, GlowSkin>;

const RARITY_TO_GLOW_SKIN: Record<string, GlowSkin> = {
  // Consumer
  default: GLOW_SKIN.CONSUMER,
  'consumer grade': GLOW_SKIN.CONSUMER,
  consumer: GLOW_SKIN.CONSUMER,
  'base grade': GLOW_SKIN.CONSUMER,
  '#b0c3d9': GLOW_SKIN.CONSUMER,

  // Industrial
  'industrial grade': GLOW_SKIN.INDUSTRIAL,
  industrial: GLOW_SKIN.INDUSTRIAL,

  // Mil-spec
  'mil-spec grade': GLOW_SKIN.MIL_SPEC,
  'mil-spec': GLOW_SKIN.MIL_SPEC,
  'high grade': GLOW_SKIN.MIL_SPEC,
  '#4b69ff': GLOW_SKIN.MIL_SPEC,
  '#4662e8': GLOW_SKIN.MIL_SPEC,

  // Restricted
  restricted: GLOW_SKIN.RESTRICTED,
  remarkable: GLOW_SKIN.RESTRICTED,
  '#8847ff': GLOW_SKIN.RESTRICTED,

  // Classified
  classified: GLOW_SKIN.CLASSIFIED,
  exotic: GLOW_SKIN.CLASSIFIED,
  '#d32ce6': GLOW_SKIN.CLASSIFIED,
  d32ce6: GLOW_SKIN.CLASSIFIED,
  '#d22ce5': GLOW_SKIN.CLASSIFIED,

  // Covert
  covert: GLOW_SKIN.COVERT,

  // Extraordinary
  extraordinary: GLOW_SKIN.EXTRAORDINARY,
  '#eb4b4b': GLOW_SKIN.EXTRAORDINARY,
  '#fa8072': GLOW_SKIN.EXTRAORDINARY,

  // Contraband
  contraband: GLOW_SKIN.CONTRABAND,
  '#e4ae39': GLOW_SKIN.CONTRABAND,
};

export const getRarityGlowSkin = (rarity: string | undefined): GlowSkin => {
  if (!rarity) {
    return GLOW_SKIN.STANDART;
  }

  const rarityLower = rarity.toLowerCase();
  return RARITY_TO_GLOW_SKIN[rarityLower] ?? GLOW_SKIN.STANDART;
};
